<template>
    <div v-if="offerList.length > 0">
        <br>
        <div class="mb-5"></div>
        <hr>
        <heading :text="'View our top business ' + prettyType + ' leasing rates'"></heading>
        <div class="row">
            <div class="col-12 offers">
                <slick ref="slickOffers" :options="slickOptions" class="card-slick">
                    <div :key="offer.id" v-for="offer in offerList" class="card-wrap">
                        <card :data="offer" ></card>
                    </div>
                </slick>
            </div>
        </div>
        <div class="text-center m-5" v-if="!presetManufacturer">
            <router-link :to="{name: 'offers', params: {type: type}}" class="button button--solid" @click.native="ctaClick()">View more offers</router-link>
        </div>
    </div>
</template>

<script>

    import Card from "./Card";
    import Heading from "./Heading";
    import Slick from "./CustomSlick";
    export default {
        props: [
            'offers',
            'type'
        ],
        components: {
            Slick,
            Heading,
            Card,
        },
        name: "CarouselCards",
        data: function() {
            return {
                slickOptions: {
                    infinite: false,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    dots: true,
                    dotsClass: "slick-dots d-none d-md-flex",
                    appendArrows: '.card-slick + .slick-paging',
                    appendDots: '.card-slick + .slick-paging',
                    responsive: [
                        {
                            breakpoint: 1200,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                            }
                        },

                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                            }
                        }
                    ]
                }
            }
        },
        computed: {
            prettyType: function() {
                return this.type === 'CAR' ? 'car' : 'van';
            },

            offerList: function() {
                return (this.offers && this.offers.length > 0) ? this.offers : [];
            },
            presetManufacturer: function(){
                return this.$store.state.PRESET_MANUFACTURER;
            },
        },
        watch:{
            offerList: function() {
                if (this.$refs.slickOffers) {
                    this.$refs.slickOffers.destroy();

                    this.$nextTick(() => {
                        if (this.$refs.slickOffers) {
                            this.$refs.slickOffers.create();
                        }
                    });
                }
            }
        },
        methods: {
            ctaClick: function() {
                this.$tracking.logCTA('SME-Price-List:CTA:More-offers');
            }
        }
    }
</script>

<style scoped lang="stylus">
    .card-wrap
        padding 0 5px
</style>